import type { FaireProductEntity } from "../../entity_types/product";

export const p_wueqxbqrdy: FaireProductEntity = {
  token: "p_wueqxbqrdy",
  type: "product",
  name: "Reishi - Fruiting Body - 1:1 Water Extracted - Organic",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/38c405290dfc2374357825e304e7d4d29cbaae3e38dcfb6aae0125eba3760419.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a25e6a43d57acdc7bd6f7993374e166f5270d2b1e3286e179bf529e891faa665.png",
    "https://cdn.faire.com/fastly/8578af357ceb4bd00fef02cd0d72f5cf43008383d8949e7c41cefa2f99b2186f.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nReishi mushroom supports resiliency. It's immune system boosting, inflammation reducing, and helps regulate stress and anxiety.\n\nOur Reishi is organically cultivated in its favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability).\n\nFun Fact: The Japanese word “Reishi” means spiritual potency and the Korean word “Youngzhi” means mushroom of immortality.\n\n\nBETA GLUCANS | 700mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:48.476Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
